import actionConstants from '../constants/';
import { matchesApiCancelKey } from '../apiCancelKeys';

const CLEARED_REQUEST_ID = '@merchant-listing/CLEARED_REQUEST';

const getmerchantList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
  activeRequestId: '',
  activeQueryKey: '',
  failedQueryKey: '',
  loadedQueryKey: '',
  screenResetId: '',
};

const getMerchantSearch = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
  activeRequestId: '',
  screenResetId: '',
};

const merchantMigrationData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
  activeRequestId: '',
  activeQueryKey: '',
  failedQueryKey: '',
  loadedQueryKey: '',
  screenResetId: '',
};

const getMigratedMerchantSearch = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
  activeRequestId: '',
  screenResetId: '',
};

const getMerchantOdsData = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: []
};

const initialState = {
  merchantList: { ...getmerchantList },
  merchantSearch: { ...getMerchantSearch },
  migrationData: { ...merchantMigrationData },
  migrationSearchData: { ...getMigratedMerchantSearch },
  merchantOdsData: {...getMerchantOdsData}
};

const isStaleResponse = (
  activeRequestId: string,
  responseRequestId?: string
) => Boolean(activeRequestId && activeRequestId !== responseRequestId);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function MerchantListingReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_MERCHANT_LIST_REQUEST:
      return {
        ...state,
        merchantList: {
          ...state.merchantList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
          activeQueryKey: action.payload?.queryKey ?? '',
          failedQueryKey: '',
        },
      };
    case actionConstants.GET_MERCHANT_LIST_SUCCESS:
      if (
        isStaleResponse(
          state.merchantList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        merchantList: {
          ...state.merchantList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
          activeQueryKey: '',
          failedQueryKey: '',
          loadedQueryKey:
            action.payload?.extra?.queryKey ?? state.merchantList.activeQueryKey,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_MERCHANT_LIST_FAILURE:
      if (
        isStaleResponse(
          state.merchantList.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        merchantList: {
          ...state.merchantList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
          activeQueryKey: '',
          failedQueryKey:
            action.payload?.extra?.queryKey ?? state.merchantList.activeQueryKey,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_MERCHANT_LIST_CLEAR:
      return {
        ...state,
        merchantList: {
          ...initialState.merchantList,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
          screenResetId:
            action.payload?.screenResetId ?? state.merchantList.screenResetId,
        },
      };

    case actionConstants.CANCEL_API_REQUEST:
      return {
        ...state,
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_MERCHANT_LIST
        )
          ? {
              merchantList: {
                ...state.merchantList,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
                activeQueryKey: '',
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.MERCHANT_SEARCH
        )
          ? {
              merchantSearch: {
                ...state.merchantSearch,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.GET_MERCHANT_MIGRATION_DATA
        )
          ? {
              migrationData: {
                ...state.migrationData,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
                activeQueryKey: '',
              },
            }
          : {}),
        ...(matchesApiCancelKey(
          action.payload,
          actionConstants.MIGRATED_MERCHANT_SEARCH
        )
          ? {
              migrationSearchData: {
                ...state.migrationSearchData,
                isLoading: false,
                activeRequestId: CLEARED_REQUEST_ID,
              },
            }
          : {}),
      };

    case actionConstants.MERCHANT_SEARCH_REQUEST:
      return {
        ...state,
        merchantSearch: {
          ...state.merchantSearch,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
        },
      };
    case actionConstants.MERCHANT_SEARCH_SUCCESS:
      if (
        isStaleResponse(
          state.merchantSearch.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        merchantSearch: {
          ...state.merchantSearch,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.MERCHANT_SEARCH_FAILURE:
      if (
        isStaleResponse(
          state.merchantSearch.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        merchantSearch: {
          ...state.merchantSearch,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.MERCHANT_SEARCH_CLEAR:
      return {
        ...state,
        merchantSearch: {
          ...initialState.merchantSearch,
          data: [],
          activeRequestId: CLEARED_REQUEST_ID,
          screenResetId:
            action.payload?.screenResetId ?? state.merchantSearch.screenResetId,
        },
      };
      
    case actionConstants.GET_MERCHANT_MIGRATION_DATA_REQUEST:
      return {
        ...state,
        migrationData: {
          ...state.migrationData,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          activeRequestId: action.payload?.requestId ?? '',
          activeQueryKey: action.payload?.queryKey ?? '',
          failedQueryKey: '',
        },
      };
    case actionConstants.GET_MERCHANT_MIGRATION_DATA_SUCCESS:
      if (
        isStaleResponse(
          state.migrationData.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        migrationData: {
          ...state.migrationData,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          activeRequestId: '',
          activeQueryKey: '',
          failedQueryKey: '',
          loadedQueryKey:
            action.payload?.extra?.queryKey ?? state.migrationData.activeQueryKey,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_MERCHANT_MIGRATION_DATA_FAILURE:
      if (
        isStaleResponse(
          state.migrationData.activeRequestId,
          action.payload?.extra?.requestId
        )
      ) {
        return state;
      }
      return {
        ...state,
        migrationData: {
          ...state.migrationData,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          activeRequestId: '',
          activeQueryKey: '',
          failedQueryKey:
            action.payload?.extra?.queryKey ?? state.migrationData.activeQueryKey,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_MERCHANT_MIGRATION_DATA_CLEAR:
      return {
        ...state,
        migrationData: {
          ...initialState.migrationData,
          data: {},
          activeRequestId: CLEARED_REQUEST_ID,
          screenResetId:
            action.payload?.screenResetId ?? state.migrationData.screenResetId,
        },
      };

      case actionConstants.MIGRATED_MERCHANT_SEARCH_REQUEST:
        return {
          ...state,
          migrationSearchData: {
            ...state.migrationSearchData,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            errorCode: 0,
            activeRequestId: action.payload?.requestId ?? '',
          },
        };
      case actionConstants.MIGRATED_MERCHANT_SEARCH_SUCCESS:
        if (
          isStaleResponse(
            state.migrationSearchData.activeRequestId,
            action.payload?.extra?.requestId
          )
        ) {
          return state;
        }
        return {
          ...state,
          migrationSearchData: {
            ...state.migrationSearchData,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            activeRequestId: '',
            // errorCode: action.payload.OpCode,
          },
        };
  
      case actionConstants.MIGRATED_MERCHANT_SEARCH_FAILURE:
        if (
          isStaleResponse(
            state.migrationSearchData.activeRequestId,
            action.payload?.extra?.requestId
          )
        ) {
          return state;
        }
        return {
          ...state,
          migrationSearchData: {
            ...state.migrationSearchData,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            activeRequestId: '',
            // errorCode: action.payload.OpCode,
          },
        };
  
      case actionConstants.MIGRATED_MERCHANT_SEARCH_CLEAR:
        return {
          ...state,
          migrationSearchData: {
            ...initialState.migrationSearchData,
            data: [],
            activeRequestId: CLEARED_REQUEST_ID,
            screenResetId:
              action.payload?.screenResetId ??
              state.migrationSearchData.screenResetId,
          },
        };
      case actionConstants.MERCHANT_ODS_DATA_SUCCESS:
        return {
          ...state,
          merchantOdsData: {
            ...state.merchantOdsData,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body
          }
        };      
      case actionConstants.MERCHANT_ODS_DATA_FAILURE:
        return {
          ...state,
          merchantOdsData: {
            ...state.merchantOdsData,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
          }
        };      case actionConstants.MERCHANT_ODS_DATA_REQUEST:
        return {
          ...state,
          merchantOdsData: {
            ...state.merchantOdsData,
            isLoading: true,
            isSuccess: false,
            isFailure: false,

          }
        };
    default:
      return state;
  }
}
